import { render } from "./Contact.vue?vue&type=template&id=e62c996a&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=e62c996a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e62c996a"

export default script